import { WixDesignSystemProvider } from "@wix/design-system";
import React, { useContext } from "react";
const UiComponentsContext = React.createContext(null);
const UiComponentsProvider = ({
  children,
  containerEl
}) => {
  return /* @__PURE__ */ React.createElement(WixDesignSystemProvider, { features: { newColorsBranding: true } }, /* @__PURE__ */ React.createElement(UiComponentsContext.Provider, { value: containerEl }, children));
};
const usePanelContainerElement = () => useContext(UiComponentsContext);
export {
  UiComponentsContext,
  UiComponentsProvider,
  usePanelContainerElement
};
//# sourceMappingURL=ui-components-provider.js.map
